//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {
  'use strict';

  $(document).on('click', '[data-filter]', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var $parent = $this.parents('[data-form="news-list"]');

    if ($parent.length) {
      var $select = $parent.find('[name=\'categories[]\']');
      var filter = $this.attr('data-filter').split(':');
      var type = filter[0].trim();
      var id = filter[1].trim();

      $select.find('option[value="' + id + '"]').prop('selected', true);
      $select.trigger('change');
    }
  });

  $('[data-search="entities"]').on('change', '.filter__item', function (ev) {
    $(this).parents('form').eq(0).submit();
  });

  $('[data-mapitem]').on('click', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var $last = $('[data-container="items"]').children().last().find('a[id]');

    $('body').addClass('loading');
    window.location = $this.attr('href') + '#' + $last.attr('id');
  });
})();
